import { Component, inject, OnDestroy, ViewChild } from "@angular/core";
import { OverlayPanel } from "primeng/overlaypanel";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FeatureTour, FeatureTourService } from "src/app/common/services/feature-tour.service";

@Component({
  selector: "app-feature-tour-button",
  templateUrl: "./feature-tour-button.component.html",
  styleUrls: ["./feature-tour-button.component.scss"],
})
export class FeatureTourButtonComponent implements OnDestroy {
  @ViewChild("tourPanel") tourPanel!: OverlayPanel;

  protected readonly featureTourService = inject(FeatureTourService);
  private readonly destroySubject = new Subject<void>();

  availableTours: FeatureTour[] = [];
  hasNewTours = false;

  // Internationalized strings
  readonly newFeaturesAvailableTooltip = $localize`:@@feature_tour_button_new_features_tooltip:Nouvelles fonctionnalités disponibles !`;
  readonly featureToursTooltip = $localize`:@@feature_tour_button_tooltip:Guide des nouvelles fonctionnalités`;
  readonly dialogTitle = $localize`:@@feature_tour_button_dialog_title:Guide des nouvelles fonctionnalités`;
  readonly startTourButtonLabel = $localize`:@@feature_tour_button_start_tour_label:Commencer`;

  constructor() {
    this.featureTourService
      .getAvailableTours()
      .pipe(takeUntil(this.destroySubject))
      .subscribe((tours) => {
        this.availableTours = tours;
      });

    this.featureTourService
      .getNewToursAvailable()
      .pipe(takeUntil(this.destroySubject))
      .subscribe((hasNew) => {
        this.hasNewTours = hasNew;
      });
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  togglePanel(event: Event): void {
    this.tourPanel.toggle(event);

    // When the panel is opened, stop the pulsing animation
    if (this.hasNewTours) {
      this.featureTourService.acknowledgeNewTours();
    }
  }

  startTour(tourId: string): void {
    this.tourPanel.hide();
    this.featureTourService.showTour(tourId);
  }
}
